export const ROUTE = {
  INDEX: '/',
  VEHICLES: '/vehicles',
  ABOUT: '/about',
  GUIDE: '/guide',
  EXPLORE: '/explore',
  SEARCH: '/search',
  TOPPICKS: '/top-picks',
  INDICATORS: '/indicators',
  BROWSE: '/browse',
  TOPIC: '/topic',
  FOLDER: '/folder',
  FAVORITES: '/favorites',
  EDITOR: '/editor',
  PROMO: '/promo',
  VIDEOS: '/videos',
  PDFS: '/component-manuals',
  TAGS: '/tags',
  ARTICLES: '/articles',
  CONTENT: '/content',
  BRAND_SPECIFIC: '/brand-specific',
}

export const BRANDS = [
  { key: 'forestriverrv', name: 'Forest River', title: 'Forest River RV' },
  { key: 'rancealuminum', name: 'Rance Aluminum', title: 'Rance Aluminum' },
  { key: 'shastarv', name: 'Shasta', title: 'Shasta RV' },
  { key: 'coachmenrv', name: 'Coachmen', title: 'Coachmen RV' },
  { key: 'dynamaxrv', name: 'Dynamax', title: 'Dynamax RV' },
  { key: 'palominorv', name: 'Palomino', title: 'Palomino RV' },
  { key: 'primetimerv', name: 'Prime Time Manufacturing', title: 'Prime Time RV' },
  { key: 'haulin', name: 'Haulin Trailers', title: 'Haulin Trailers' },
  { key: 'lightningtrailers', name: 'Lightning Trailers', title: 'Lightning Trailers' },
  { key: 'southbaypontoon', name: 'South Bay', title: 'South Bay Pontoon' },
  { key: 'trifectapontoon', name: 'Trifecta', title: 'Trifecta Pontoon' },
  { key: 'berkshirepontoon', name: 'Berkshire', title: 'Berkshire Pontoon' },
  { key: 'uscargo', name: 'US Cargo', title: 'US Cargo' },
  { key: 'continentalcargotrailers', name: 'Continental Cargo', title: 'Continental Cargo' },
  { key: 'cargomatetrailer', name: 'Cargo Mate', title: 'Cargo Mate' },
  { key: 'easttowest', name: 'East To West', title: 'East To West' },
  { key: 'cargoking', name: 'Cargo King', title: 'Cargo King' },
  { key: 'ameralite', name: 'AmeraLite', title: 'AmeraLite' },
  { key: 'force', name: 'Force', title: 'Force' },
  { key: 'nepallopontoons', name: 'Nepallo', title: 'Nepallo Pontoons' },
  { key: 'dockside', name: 'Dockside', title: 'Dockside' }
]

export const APP_VERSION = process.env.REACT_APP_VERSION || '2.1.x-dev'

export const VEHICLE_FAMILIES = {}

export const DEFAULT_PUBLICATION_TYPE = 'OG'

export const OWNERS_MANUAL_PDF_LOCALES = ['en_US', 'fr_CA']

export const GOOGLE_ANALYTICS_APP_TYPE = 'Web'

export const GOOGLE_ANALYTICS_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyBkTMd9pyk9O1-k_ne-_tq_-Wtd7Xoa-n8',
  authDomain: 'forestriver-f91a1.firebaseapp.com',
  databaseURL: 'https://forestriver-f91a1.firebaseio.com',
  projectId: 'forestriver-f91a1',
  storageBucket: 'forestriver-f91a1.appspot.com',
  messagingSenderId: '267678725300',
  appId: '1:267678725300:web:a7f4662f2cd641986153e1',
  measurementId: 'G-9YL8VZCL20',
}

export const ENV_PROD = 'Prod'
export const ENV_STAGE = 'Stage'

//TODO: remove CLIENT_ID & CLIENT_SECRET from config after public access configured
export const CONTENT_DELIVERY = {
  [ENV_PROD]: {
    BASE_URL: 'https://content.forest-river.tweddle.io',
    CLIENT_ID: 'forest-river-oi',
    CLIENT_SECRET: 'fcdb38e6-00ed-4a54-b3fb-a4397d9f1176',
  },
  [ENV_STAGE]: {
    BASE_URL: 'https://content.forest-river.tweddle.tech',
    CLIENT_ID: 'forest-river-oi',
    CLIENT_SECRET: '8f643b44-ed4d-4824-b91a-c5e0d79c99f6',
  },
}

// WARNING! Do not use this value directly, only with initCore/getConfig from tw-oi-core
export const CORE = {
  FEATURE_ENABLED_FAVORITES: false,
  SKIP_PRELOAD_HEROSHOT_IMAGE: true,
  FEATURE_ENABLED_INTRO: false,
  FEATURE_ENABLED_PROMO: false,
  // Better disable popup ONLY together with Intro ENABLED because of "Decline" and "Back" buttons should lead somewhere
  FEATURE_ENABLED_TERMS_POPUP: true,
  FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW: false,

  BASE_URL: process.env.REACT_APP_BASE_URL || CONTENT_DELIVERY.Prod.BASE_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID || CONTENT_DELIVERY.Prod.CLIENT_ID,
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET || CONTENT_DELIVERY.Prod.CLIENT_SECRET,

  DEFAULT_BRAND: process.env.REACT_APP_DEFAULT_BRAND || BRANDS[0].name,

  BROWSE_FOLDERS_KEYS: ['id', 'type', 'title', 'resourceKey', 'contents', 'alias', 'video', 'bodyHtml'],

  IMAGE_MAPS_ORDER: [
    'Exterior',
    'WideCabin',
    'DriverSeat',
    'FrontSeat',
    'RearSeat',
    'Rear',
    'TruckBed',
    'Hatch',
    'Cargo',
    'SteeringWheel',
    'IP', // 'InstrumentPanel'
  ],

  // Analytics setup >

  FULL_STORY_ORG_CODE_BY_ENV: {
    'forestriverinc.help': 'GQ8CZ',
  },

  FULL_STORY_DEBUG: false,

  DEFAULT_GROUP: 'Cars',

  // Load user's settings stored locally
  LOAD_USER_SETTINGS: true,

  ERROR_LOG_ENDPOINT: '/logs',
}

export const UI = {
  OWNERS_MANUAL: "Owner's Manual",

  HERO_SHOT_SMALL_SIZE: 'small',
  HERO_SHOT_MEDIUM_SIZE: 'medium',

  MENU_TITLE_SELECT_MODEL: {
    desktop: 'Select Model',
    mobile: 'Select Another Model',
  },

  VEHICLES_SCREEN_HEAD_TITLE: 'Select Model',
  ALL_MODELS: 'All Models',
  ALL_TYPES: 'All Types',

  SEARCH_BOX_DELAY: 500,
  SEARCH_MIN_CHARACTERS: 3,

  ANIMATION_DELAY: 300,
  FRAME_DELAY: 300,
  REM_SIZE: 20,
  MOBILE_WIDTH: 320,
  MIN_DESKTOP_WIDTH: 768,
  MAX_DESKTOP_WIDTH: 1024,
  EXPLORE_ZOOM: 2,

  NO_FOLDER_TITLE: 'Filter by category',
  ALL_FOLDERS_TITLE: 'All Categories',
  BROWSE_TITLE: 'Browse',
  VEHICLE_FILTER_ALL: 'All',

  TOAST_FADEOUT_TIME: 500,

  ASSOCIATED_CONTENT: 'Associated Content',

  // These values are hardcoded here for a reason
  // SEE: https://tweddle.atlassian.net/browse/TWSDEL-1058
  EXPLORE_IMAGE_WIDTH: 800,
  EXPLORE_IMAGE_HEIGHT: 490,
  EXPLORE_HOTSPOT_SIZE: 40,
  EXPLORE_ZOOM_ANIMATION: { stiffness: 250, damping: 25 },

  GROUP_MARGIN: 30,

  SCROLL_TYPE_MANUAL: 'manual',
  SCROLL_TYPE_USER: 'user',

  MODAL_ID_TERMS: 'terms',

  RELATED_CONTENT_MORE_VIDEOS: 'More Videos',

  RELATED_CONTENT_PANEL_TITLE: {
    VIDEOS: 'Videos',
    PDFS: 'PDFs',
    TOPIC: 'Topic',
  },

  NO_RELATED_CONTENT: {
    VIDEOS: 'No related videos',
    PDFS: 'No related PDFs',
  },

  OWNERS_MANUAL_PDF_TITLE: {
    en_US: 'English',
    fr_CA: 'Français',
  },

  URL_APPSTORE: 'https://itunes.apple.com/us/app/forest-river-rv-owner-digital/id909910087?mt=8',
  URL_PLAYMARKET: 'https://play.google.com/store/apps/details?id=com.forestriverinc.ForestRiver',

  PROMO_MSG: 'Download the mobile app to gain access to your Owner’s Manual when you’re not connected.',

  STICKY_VEHICLES_BAR_HEIGHT: 130,
}

export const MESSAGE = {
  CONFIRM_REMOVE_FAVORITE: 'Are you sure you want remove this topic from Favorites?',
  ROTATE_DEVICE_ORIENTATION: 'Please rotate your device to portrait orientation for a better experience with the app',

  EMPTY_FAVORITES: 'No topics added yet',
  FAVORITES: 'Favorites',
  EMPTY_RECENT: 'No topics viewed yet',
  EMPTY_TOPICS: 'No topics found',
  EMPTY_VEHICLES: 'No vehicles found',
  COMING_SOON: 'Coming soon',

  ERROR_GLOBAL: 'Something went wrong',
  ERROR_RETRY: 'Please retry in a while',
  ERROR_TRY_AGAIN_LATER: 'Please try again later',
  ERROR_VEHICLE_NOT_FOUND: 'Vehicle not found',
  ERROR_VEHICLE_RETRY: 'Try to select another vehicle',
  ERROR_NOT_FOUND: 'Page Not found',
  ERROR_NOT_FOUND_MESSAGE: "The page you've requested was not found",
  ERROR_VIDEO_NOT_AVAILABLE: 'Sorry, this video is not available',
  INFORMATION_IS_BEING_UPDATED:
    'This information is currently being updated or repaired, and should be available again soon',
  GO_BACK: 'Go Back',

  NO_RECENTLY_VIEWED: 'No Recently Viewed',
  RECENTLY_VIEWED: 'Recently Viewed',
  NO_RESULTS_FOUND: 'No Results Were Found',
  SEARCH_RESULTS: 'Search Results',
  FORGOT_PASSWORD: 'Please contact your PubHub administrator and request a password reset.',
}

export const PRODUCT_MAP = {
  MOTORHOME: {
    title: 'Motorhomes',
    heroShotIcon: 'motorhomes',
  },
  TOY_HAULER: {
    title: 'Toy Haulers',
    heroShotIcon: 'toy-hauler',
  },
  FIFTH_WHEEL: {
    title: 'Fifth Wheels',
    heroShotIcon: 'fifth-wheel',
  },
  TRAVEL_TRAILER: {
    title: 'Travel Trailers',
    heroShotIcon: 'travel-trailer',
  },
  CAMPING_TRAILER: {
    title: 'Camping Trailers',
    heroShotIcon: 'camping-trailer',
  },
  CARGO_TRAILER: {
    title: 'Cargo Trailers',
    heroShotIcon: 'cargo-trailer',
  },
  PONTOON: {
    title: 'Pontoons',
    heroShotIcon: 'pontoon',
  },
  TRUCK_CAMPER: {
    title: 'Truck Campers',
    heroShotIcon: 'truck-camper',
  },
}

export const PRODUCT_SUBTYPE_MAP = {
  CLASS_A_DIESEL: 'Class A Diesel',
  CLASS_A_GAS: 'Class A Gas',
  CLASS_B: 'Class B',
  CLASS_C: 'Class C',
  TRAVEL_TRAILER: 'Travel Trailer',
  FIFTH_WHEEL: 'Fifth Wheel',
  CONVENTIONAL: 'Conventional',
  LITE: 'Lite',
  HYBRID: 'Hybrid',
  TOY_HAULER: 'Toy Hauler',
  All: 'All',
}

export const HTML_URL_PLACEHOLDERS = {
  Forest_River_Home_pg_URL: 'http://www.forestriverinc.com/#&panel1-1',
  Forest_River_NHTSA_URL: 'https://www.safercar.gov/',
  Forest_River_water_quality_URL: 'https://www.wqa.org/',
  Forest_River_contact_us_URL: 'http://www.forestriverinc.com/ContactUs.aspx',
  Forest_River_tire_safety_pdf_pg_URL: 'https://one.nhtsa.gov/cars/rules/TireSafety/ridesonit/tires_index.html',
  Forest_River_dexteraxle_URL: 'http://www.dexteraxle.com/',
  Forest_River_lcil_URL: 'https://www.lci1.com/',
  'Forest_River_al-ko_axis_URL': 'http://www.al-ko.us/',
  Forest_River_ABYC_URL: 'https://abycinc.org/?',
  Forest_River_Tumacs_covers_URL: 'https://www.tumacscovers.com/',
  Forest_River_Clarion_URL: 'https://www.clarion.com/us/en/products-personal/marine/',
  Forest_River_home_marine_pg_URL: 'http://www.forestriverinc.com/pontoons.aspx',
  Forest_River_NMMA_URL: 'http://www.nmma.org/',
}

export const CONTENT_TYPE = {
  VIDEO: 'video',
  TOPIC: 'topic',
  PUBLICATION: 'publication',
  PAGE: 'page',
  FOLDER: 'folder',
  ARTICLE: 'article',
  PDF: 'pdf',
}
